var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"signUp position-relative w-100 h-100"},[_c('editMemberHeader'),_c('main',{staticClass:"signUp__main position-relative w-100 editMember"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }